module.exports = "/static/media/news_icon.99f024b3.svg";